import {
  DatasetTableConfig,
  TableConfigBuilder,
  textColumn,
  crudActions,
} from '@ui/lib/ui-kit/ui-dataset-table';
import { CustomEventModel } from '@models/custom-event.model';

export function createCustomEventsTableConfig(): DatasetTableConfig<CustomEventModel.CustomEvent> {
  return new TableConfigBuilder<CustomEventModel.CustomEvent>()
    .columns([
      textColumn<CustomEventModel.CustomEvent>(
        'name',
        'CUSTOM_EVENTS.TABLE.NAME',
        {
          width: 'minmax(200px, 1fr)',
          mobileVisible: true,
        },
      ),

      textColumn<CustomEventModel.CustomEvent>(
        '_id',
        'CUSTOM_EVENTS.TABLE.ID',
        {
          width: 'minmax(100px, 0.5fr)',
          mobileVisible: true,
          cardIcon: 'ui-icon-key'
        },
      ),
    ])
    .actions(crudActions<CustomEventModel.CustomEvent>())
    .trackBy('_id')
    .build();
}
